import { Map } from "mapbox-gl"
import { state } from "../state"
import { createIntersectGeoTargetLayers, getAllGeoTargetintersectLayerIds } from "./geo-targets"
import { createCoordinatesLayers, getGeoTargetCoordinateLayerIds } from "./geo-targets-coordinate"
import { createShapeLayers, getGeoTargetShapeLayerIds } from "./geo-targets-shape"

export function activateInventoryGeoTargetsView(): void {
  const { map } = state.inventory
  if (!map) {
    return
  }
  setInventoryGeoTargetsLayersVisibility("visible")
}

export function deactivateInventoryGeoTargetsView(): void {
  const { map } = state.inventory
  if (!map) {
    return
  }
  setInventoryGeoTargetsLayersVisibility("none")
}

export function getClickableInventoryGeoTargetsLayerIds(): string[] {
  // no layer are clickable for inventory geo-targets map
  return []
}

export function createInventoryMapGeoTargetsLayers(map: Map): void {
  createShapeLayers(map, true)
  createCoordinatesLayers(map, true)
  createIntersectGeoTargetLayers(map)
}

function setInventoryGeoTargetsLayersVisibility(visibility: "none" | "visible"): void {
  const map = state.inventory.map
  if (!map) {
    return
  }
  const layerIds = getAllInventoryGeoTargetLayers()
  for (const layerId of layerIds) {
    if (map.getLayer(layerId)) {
      if (map.getLayoutProperty(layerId, "visibility") !== visibility) {
        map.setLayoutProperty(layerId, "visibility", visibility)
      }
    }
  }
}

function getAllInventoryGeoTargetLayers(): string[] {
  return [...getAllGeoTargetintersectLayerIds(), ...getGeoTargetCoordinateLayerIds(), ...getGeoTargetShapeLayerIds()]
}
